import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import All_Waivers from "./components/All_Waivers";
import Computer_Repair_Waiver from "./components/Computer_Repair_Waiver";
import Computer_Repair_Waivers from "./components/Computer_Repair_Waivers";
import Anti_Virus_Inspection_Waiver from "./components/Anti_Virus_Inspection_Waiver";
import Anti_Virus_Inspection_Waivers from "./components/Anti_Virus_Inspection_Waivers";
import Completion_Certificate from "./components/Completion_Certificate";
import Completion_Certificates from "./components/Completion_Certificates";
import Data_Backup_Waiver from "./components/Data_Backup_Waiver";
import Data_Backup_Waivers from "./components/Data_Backup_Waivers";
import Hard_Drive_Inspection_Waiver from "./components/Hard_Drive_Inspection_Waiver";
import Hard_Drive_Inspection_Waivers from "./components/Hard_Drive_Inspection_Waivers";
import Network_Inspection_Waiver from "./components/Network_Inspection_Waiver";
import Network_Inspection_Waivers from "./components/Network_Inspection_Waivers";
import Refund_Agreement from "./components/Refund_Agreement";
import Refund_Agreements from "./components/Refund_Agreements";

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import UserRoles from "../../../../constants/UserRoles";
import Collection from "../customers/components/Customers";
import Object from "../phone_log/components/PhoneLog";

export default ({match, regions, roles}) => (

	<Switch>


		{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
			<ErrorBoundaryRoute exact path={`${match.url}/computer_repair_waivers/:id`}>
				<Computer_Repair_Waiver regions={regions} baseUrl={match.url}/>
			</ErrorBoundaryRoute>}

		{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
			<ErrorBoundaryRoute exact path={`${match.url}/anti_virus_inspection_waivers/:id`}>
				<Anti_Virus_Inspection_Waiver regions={regions} baseUrl={match.url}/>
			</ErrorBoundaryRoute>}

		{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
			<ErrorBoundaryRoute exact path={`${match.url}/completion_certificates/:id`}>
				<Completion_Certificate regions={regions} baseUrl={match.url}/>
			</ErrorBoundaryRoute>}

		{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
			<ErrorBoundaryRoute exact path={`${match.url}/data_backup_waivers/:id`}>
				<Data_Backup_Waiver regions={regions} baseUrl={match.url}/>
			</ErrorBoundaryRoute>}

		{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
			<ErrorBoundaryRoute exact path={`${match.url}/hard_drive_inspection_waivers/:id`}>
				<Hard_Drive_Inspection_Waiver regions={regions} baseUrl={match.url}/>
			</ErrorBoundaryRoute>}

		{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
			<ErrorBoundaryRoute exact path={`${match.url}/network_inspection_waivers/:id`}>
				<Network_Inspection_Waiver regions={regions} baseUrl={match.url}/>
			</ErrorBoundaryRoute>}

		{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
			<ErrorBoundaryRoute exact path={`${match.url}/refund_agreements/:id`}>
				<Refund_Agreement regions={regions} baseUrl={match.url}/>
			</ErrorBoundaryRoute>}

		<ErrorBoundaryRoute exact path={`${match.url}`}>
			<All_Waivers regions={regions} roles={roles}/>
		</ErrorBoundaryRoute>

		<ErrorBoundaryRoute exact path={`${match.url}/all_forms`}>
			<All_Waivers regions={regions} roles={roles}/>
		</ErrorBoundaryRoute>

		<ErrorBoundaryRoute exact path={`${match.url}/computer_repair_waivers`}>
			<Computer_Repair_Waivers regions={regions} roles={roles}/>
		</ErrorBoundaryRoute>

		<ErrorBoundaryRoute exact path={`${match.url}/anti_virus_inspection_waivers`}>
			<Anti_Virus_Inspection_Waivers regions={regions} roles={roles}/>
		</ErrorBoundaryRoute>

		<ErrorBoundaryRoute exact path={`${match.url}/completion_certificates`}>
			<Completion_Certificates regions={regions} roles={roles}/>
		</ErrorBoundaryRoute>

		<ErrorBoundaryRoute exact path={`${match.url}/data_backup_waivers`}>
			<Data_Backup_Waivers regions={regions} roles={roles}/>
		</ErrorBoundaryRoute>

		<ErrorBoundaryRoute exact path={`${match.url}/hard_drive_inspection_waivers`}>
			<Hard_Drive_Inspection_Waivers regions={regions} roles={roles}/>
		</ErrorBoundaryRoute>

		<ErrorBoundaryRoute exact path={`${match.url}/network_inspection_waivers`}>
			<Network_Inspection_Waivers regions={regions} roles={roles}/>
		</ErrorBoundaryRoute>

		<ErrorBoundaryRoute exact path={`${match.url}/refund_agreements`}>
			<Refund_Agreements regions={regions} roles={roles}/>
		</ErrorBoundaryRoute>
		<ErrorBoundaryRoute>
			<Redirect to={'/kt_forms'}/>
		</ErrorBoundaryRoute>
	</Switch>
);
